<div class="homepageWrapper">
  <app-uu-header></app-uu-header>
  <app-uu-services></app-uu-services>
  <app-services-image-section></app-services-image-section>
  <div class="clientComponent">
    <app-client></app-client>
  </div>
  <app-uu-gold-standard></app-uu-gold-standard>
  <app-csc-stats></app-csc-stats>
  <app-uu-locations></app-uu-locations>
  <app-uu-dhs></app-uu-dhs>
  <app-associations></app-associations>
  <app-footer></app-footer>
</div>
